<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <p class="login-tip"></p>
        </div>
      </Card>
    </div>
    <div class="login-img">
      <img src="../../assets/images/logoCon.png" alt="">
    </div>
  </div>
</template>
<script>
  import LoginForm from '_c/login-form'
  import { mapActions } from 'vuex'
  export default {
    components: {
      LoginForm
    },
    mounted () {
      this.Specialeffects();
    },
    methods: {
      Specialeffects () {
        let loginImg = document.getElementsByClassName('login-img')[0];
        // let loginCon = document.getElementsByClassName('login-con')[0];
        let timer = null;
        clearInterval(timer);
          timer = setInterval(function () {
            var current = loginImg.offsetLeft;
            var step = (270 - current) / 10;
            step = Math.ceil(step);
            current += step;
            loginImg.style.left = current + 'px';
            if (current === 270) {
              clearInterval(timer);
            }
          }, 20);
      },
      ...mapActions([
        'handleLogin',
        'getUserInfo'
      ]),
      handleSubmit ({ userName, password, type, platform }) {
        this.handleLogin({ userName, password, type, platform }).then(res => {
          if (res.success) {
            this.$router.push({
              name: this.$config.homeName
            })
          } else {
            this.$Message.error(res.msg);
          }
        })
      }
    }
  }
</script>

<style>

</style>
